<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
import msalInstance from './auth/msalInstance'
import { loginRequest } from './auth/msalConfig'

export default {
  name: 'App',
  async created() {
    try {
      await msalInstance.initialize()
      const response = await msalInstance.handleRedirectPromise()

      if (response) {
        // Returning from Azure AD redirect login
        const ok = await this.$store.dispatch('loginSuccess', response)
        if (ok) this.$router.push('/regattas')
      } else {
        // Check for an existing cached session
        const accounts = msalInstance.getAllAccounts()
        if (accounts.length > 0) {
          const silent = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          })
          const ok = await this.$store.dispatch('loginSuccess', silent)
          if (ok && this.$route.path === '/login') {
            this.$router.push('/regattas')
          }
        }
      }
    } catch (e) {
      console.error('MSAL init error:', e)
      this.$store.commit('SET_NOTIFICATION', {
        text: 'Authentication initialisation failed. Please refresh the page.',
        color: 'error',
        icon: 'mdi-alert-circle'
      })
    }
  }
}
</script>

<style>
:root {
  background-color: #333333;
}
* {
  font-family: 'DM Sans', sans-serif !important;
}
</style>
